import { render, staticRenderFns } from "./confirmDialogTemplate.vue?vue&type=template&id=65929508&scoped=true&"
import script from "./confirmDialogTemplate.vue?vue&type=script&lang=js&"
export * from "./confirmDialogTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65929508",
  null
  
)

export default component.exports